import CASL from '@/utils/constants/casl'

export default {
  path: 'delete-chassisnumber',
  children: [
    {
      path: '',
      name: 'delete-chassisnumber.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.HAPUS_NO_RANGKA
      },
      component: () => import('./list/DeleteChassisNumberList.vue')
    },
    {
      path: 'add/delete-chassisnumber',
      name: 'delete-chassisnumber.add',
      meta: {
        action: 'create',
        subject: CASL.ACCESS.HAPUS_NO_RANGKA
      },
      component: () => import('./form/FormDeleteNoRangka.vue')
    }
  ]
}
